import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { TelemetryService } from '@aston/foundation';
import { Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class AppErrorHandler implements ErrorHandler {
	private injector = inject(Injector);

	_events = new Subject()
	events$ = this._events.asObservable()

	handleError(error: any): void {
		this._events.next(error)
		try {
			const monitoringService = this.injector.get(TelemetryService);
			monitoringService.error(error);
		} catch (e) {
			console.warn(`[app] could not use telemetry`, e)
			console.warn(`[app] this is could happen with conflicting browser extensions like SeleniumIDE, Deepl or others`)
		}
		console.error(error);
	}
}
